// extracted by mini-css-extract-plugin
export default {"avatar":"InstructorHeader_avatar__W5o3H","logo":"InstructorHeader_logo__72VCM","student":"InstructorHeader_student__y-pSC"};